import BaseButtonRow from "../../../components/elements/BaseButtonRow"
import BaseFilterButton from "../../../components/elements/BaseFilterButton"
import { ReactComponent as ARROWUP } from "../../../assets/ArrowUpIcon.svg"
import { ReactComponent as ARROWDOWN } from "../../../assets/ArrowDownIcon.svg"
import BaseSearchInputField from "../../../components/elements/BaseSearchInputField"

type SearchbarAndNavigationButtonsType = {
    searchTerm: string
    searchBarPlaceholder: string
    sortDirection: boolean
    setsearchTerm: (e: any) => void
    sort: () => void
    showFilter: () => void
}

export default function SearchbarAndNavigationButtons(props: SearchbarAndNavigationButtonsType) {
    return (
        <BaseButtonRow classProps="justify-between">
            <div className="flex gap-4 w-full sm:w-fit">
                <BaseSearchInputField 
                    searchFunction={props.setsearchTerm} 
                    value={props.searchTerm ?? null}
                    placeholder={props.searchBarPlaceholder}
                    classProps="text-sm w-56 sm:w-80 md:w-96 truncate rounded-default bg-none border-none shadow-lg p-4 text-base-200"
                />
            </div>
            <div className="flex flex-row gap-2">
               
                <button className="hidden sm:flex btn bg-white shadow-lg border-none hover:bg-white/40" onClick={props.sort}>
                    {props.sortDirection ? <ARROWUP className="w-4 h-4" /> : <ARROWDOWN className="w-4 h-4" />}
                </button>
                <BaseFilterButton func={props.showFilter} />
            </div>
        </BaseButtonRow>
    )
}
